<div class="carousel-container">
  <div class="slider-wrapper">
    <div class="slide" *ngFor="let slide of slides; let i = index" 
         [class.active]="i === currentIndex"
         [class.content-left]="slide.textPosition === 'left'"
         [class.content-right]="slide.textPosition === 'right'"
         [class.content-center]="slide.textPosition === 'center'">
      <div class="slide-background" [style.background-image]="'url(' + slide.image + ')'"></div>
      <div class="slide-content">
        <h2 class="slide-title">{{ slide.title }}</h2>
        <h3 class="slide-subtitle">{{ slide.subtitle }}</h3>
              <p class="slide-description">{{ slide.description }}</p>
        <button class="cta-button" (click)="navigateTo(slide.ctaLink)">
                {{ slide.ctaText }}
              </button>
          </div>
        </div>
      </div>
      
  <div class="slider-controls">
    <button class="control-button prev" (click)="previousSlide()">
      <i class="fas fa-chevron-left"></i>
    </button>
    <div class="pagination">
      <button *ngFor="let slide of slides; let i = index" 
              class="pagination-bullet" 
              [class.active]="i === currentIndex"
              (click)="goToSlide(i)">
      </button>
    </div>
    <button class="control-button next" (click)="nextSlide()">
      <i class="fas fa-chevron-right"></i>
    </button>
    </div>
  </div>